import { useState } from 'react';

import { useParams } from 'react-router-dom';

import dayjs from 'dayjs';

import { Spin, Button } from 'antd';
import { ExportOutlined } from '@ant-design/icons';

import { t } from 'i18next';

import EventKPIbanner from '@/components/EventKPIbanner';

import SemiPage from '@/components/SemiPage';

import PDFViewer from '@/components/PDFViewer';
// import DashboardTimeline from '@/components/DashboardTimeline';

import { useGetWeatherEventDetails } from '@/data/hooks';

import './style.css';
import P4RMap2 from '@/components/P4RMap2';
import EmbeddedTimeline from '@/components/EmbeddedTimeline';

export default function EventReport() {
  const { weatherEventId } = useParams();

  const [activeFullPage, setActiveFullPage] = useState<string | null>(null);

  const handleToggle = (type: string) => {
    setActiveFullPage(activeFullPage === type ? null : type);
  };

  const { data: weatherEventDetails, isLoading: weatherEventDetailsIsLoading } =
    useGetWeatherEventDetails(weatherEventId) as {
      data: IDistrictWeatherEvents | undefined;
      isLoading: boolean;
    };

  const eventStartDate = weatherEventDetails?.startDatetime
    ? dayjs.utc(weatherEventDetails.startDatetime)
    : undefined;
  const eventEndDate = weatherEventDetails?.endDatetime
    ? dayjs.utc(weatherEventDetails.endDatetime)
    : undefined;

  // console.log('weatherEventDetails :>> ', weatherEventDetails);

  return (
    <div className="page-EventReport">
      <div className="EventReport-KPI">
        <Spin spinning={weatherEventDetailsIsLoading}>
          <EventKPIbanner />
        </Spin>
      </div>
      <div className="EventReport-PdfAndMap">
        <SemiPage
          type="pdf"
          title={t('metOfficeReport')}
          extra={
            weatherEventDetails?.metOfficeReport?.reportSource && (
              <a
                href={weatherEventDetails.metOfficeReport.reportSource}
                target="_blank"
                rel="noopener noreferrer"
              >
                <Button type="primary" icon={<ExportOutlined />}>
                  Source
                </Button>
              </a>
            )
          }
          activeFullPage={activeFullPage}
          onToggle={handleToggle}
          loading={weatherEventDetailsIsLoading}
        >
          <PDFViewer
            url={weatherEventDetails?.metOfficeReport?.reportUrl}
            zoom
          />
        </SemiPage>
        <SemiPage
          type="map"
          title={
            weatherEventDetails?.name?.toLocaleUpperCase() ||
            'Weather Event Map'
          }
          activeFullPage={activeFullPage}
          onToggle={handleToggle}
          loading={weatherEventDetailsIsLoading}
        >
          <EmbeddedTimeline
            startDate={eventStartDate}
            endDate={eventEndDate}
            comparison
            defaultMode="historical"
          />
          <P4RMap2
            hideDistricts
            hideSubstations
            comparison
            rasterService="era5"
          />
        </SemiPage>
      </div>
    </div>
  );
}
